//Show Products on Page Load

(function($) {
	$(document).ready(function() {

		//Function for sending email
		$(".make-order").submit( function(e) {
			e.preventDefault();

			mcs_triggerSpinner();

			$.ajax({
				type:     "post",
				dataType: "json",
				url:      mcs_data.ajax_url,
				data: {
					action:       "visitor_email",
					client_cart:  $("#email__encs").val(), // ???
					client_name:  $("#client__name").val(),
					client_email: $("#email__email").val(),
					client_phone: $("#phone__phone").val(),
				},
				success: function(response) {

					if( response.success == true ) {
						$("#email__encs").val('');
						$("#client__name").val('');
						$("#email__email").val('');
						$("#phone__phone").val('');

						$("#email__status").css({"display": "block", "background-color": "#54790d", "color": "#ffffff"});
						$("#email__status").html( response.data );
						setTimeout(
							function()
							{
								$("#email__status").css({"display": "block", "background-color": "#ffffff", "color": "#ffffff"});
								$("#email__status").html('');
							}, 5000);
						return;
					}
					$("#email__status").css({"display": "block", "background-color": "#e81010", "color": "#ffffff"});
					$("#email__status").html( response.data );
					setTimeout(
						function() {
							$("#email__status").css({"display": "block", "background-color": "#ffffff", "color": "#ffffff"});
							$("#email__status").html('');
						},
						5000
					);
				},
				always: function(){
					mcs_hideSpinner();
				}
			});
		});

		//Function for search ref click enter key
		$("#search__ref").keyup( function(e) {
			if (e.keyCode === 13) {

				mcs_triggerSpinner();
				$.ajax({
					type:     "post",
					dataType: "json",
					url:      mcs_data.ajax_url,
					data: {
						action: "search_ref",
						ref:    $("#search__ref").val(),
					}
				})
				.done( function(response) {
					if( response.success == true ) {
						$(".entry-content").html(response.data['content']);
						return;
					}
				} )
				.fail( function( jqXHR, textStatus, errorThrown ){
					mcs_hideSpinner();
					console.debug( 'The following error occured: ' + textStatus, errorThrown );
				})
				.always( function(){
					mcs_hideSpinner();
				});

			}
		});
	});
})(jQuery);
